import * as React from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import {
  PageSelector,
  PageControl,
  PagePrev,
  PageNext,
  PageNumber,
  PageLengthDescription,
  PageLengthSelect,
} from "../Pagination.styles";

import { PageContext } from "../../../../context/numbered-pagination";

interface IAccountsPaginationProps {
  className?: string;
  isLoading: boolean;
  total: number;
  handleLoadMoreUsers: () => void;
  handleUsersPerPageChange: (perPage: number) => void;
}

const AccountsPagination: React.FC<IAccountsPaginationProps> = props => {
  const { className, total, handleLoadMoreUsers, isLoading, handleUsersPerPageChange } = props;
  const { pageIndex, perPage, maxPreloadedPage, setPageIndex, setPerPage } = React.useContext(PageContext);
  const [maxPageReached, setMaxPageReached] = React.useState<number>(0);

  const selectPerPage = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newPerPage = parseInt(e.target.value, 10);
    setPageIndex(0);
    setMaxPageReached(0);
    setPerPage(newPerPage);
    handleUsersPerPageChange(newPerPage);
  };
  const totalPages = Math.ceil(total / perPage);
  const prevPage = () => setPageIndex(pageIndex - 1);
  const nextPage = () => {
    const newIndex = pageIndex + 1;
    setPageIndex(newIndex);
    if (newIndex > maxPageReached && newIndex > maxPreloadedPage) {
      handleLoadMoreUsers();
      setMaxPageReached(newIndex);
    }
  };

  return (
    <PageControl className={className}>
      <PageLengthDescription>
        Rows per page:
        <PageLengthSelect value={perPage} onChange={selectPerPage} data-testid="page-length-select">
          <option value={10}>10</option>
          <option value={20}>20</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
          <option value={500}>500</option>
        </PageLengthSelect>
      </PageLengthDescription>
      <PageSelector data-testid="page-selector">
        <PagePrev disabled={pageIndex === 0 || isLoading} Icon={FaChevronLeft} onClick={prevPage} />
        <PageNumber selected={true}>{<strong>{pageIndex + 1}</strong>}</PageNumber>
        <PageNext disabled={pageIndex >= totalPages - 1 || isLoading} Icon={FaChevronRight} onClick={nextPage} />
      </PageSelector>
    </PageControl>
  );
};

export default AccountsPagination;
